import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    DatePickerFormInputFabric,
    SelectFormInput,
    TextAreaFormInput,
} from "../../../components/form/index";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    findLookupValue,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { actions } from "react-redux-form";
import * as CollectionInstanceTrackerPageActions from "../../../actions/pages/collectionInstanceTrackerPage";
import { Modal } from "../../../components/common/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { ModalSize } from "../../../enumerations/ModalSize";
import { convertToShortDateString } from "../../../helpers/date";
import { ITmdState } from "../../../reducers/index";

interface ICollectionInstanceTrackerPageProps {
    collectionInstanceId: number;
    values: Dtos.CollectionInstanceTracker[];
    lookups: Dtos.Lookup[];
    modalOpen: boolean;
    isValid: boolean;
    collectionInstanceTrackerIndex: number;
    collectionInstanceTracker?: Dtos.CollectionInstanceTracker;
}

interface ICollectionInstanceTrackerPageActions {
    addCollectionInstanceTracker: CollectionInstanceTrackerPageActions.ICollectionInstanceTrackerPageCreateCollectionTrackerActionCreator;
    editCollectionInstanceTracker: CollectionInstanceTrackerPageActions.ICollectionInstanceTrackerPageEditCollectionTrackerActionCreator;
    updateCollectionInstanceTracker: CollectionInstanceTrackerPageActions.ICollectionInstanceTrackerPageUpdateCollectionTrackerActionCreator;
    resetCollectionInstanceTracker: CollectionInstanceTrackerPageActions.ICollectionInstanceTrackerPageResetCollectionTrackerActionCreator;

    changeForm: typeof actions.change;
}

type CollectionInstanceTrackerPageProps = ICollectionInstanceTrackerPageProps &
    ICollectionInstanceTrackerPageActions;

const reduxFormName: string = "reduxForms.collectionInstanceTrackerPage";

class CollectionInstanceTrackerPage extends React.PureComponent<
    CollectionInstanceTrackerPageProps,
    any
> {
    constructor(props: CollectionInstanceTrackerPageProps) {
        super(props);

        this.onAdd = this.onAdd.bind(this);
        this.onUpdate = this.onUpdate.bind(this);
    }

    onAdd() {
        if (this.props.addCollectionInstanceTracker) {
            this.props.addCollectionInstanceTracker(
                this.props.collectionInstanceId
            );
        }
    }

    onUpdate() {
        const {
            resetCollectionInstanceTracker,
            values,
            collectionInstanceTrackerIndex,
            collectionInstanceTracker,
            changeForm,
        } = this.props;

        var newValues = [...values];

        if (collectionInstanceTrackerIndex == -1) {
            // add
            newValues.push({ ...collectionInstanceTracker });
        } else {
            // update
            newValues[collectionInstanceTrackerIndex] = {
                ...collectionInstanceTracker,
            };
        }
        changeForm(
            "reduxForms.collectionInstance.collectionInstanceTrackers",
            newValues
        );
        resetCollectionInstanceTracker();
    }

    renderModal() {
        const {
            modalOpen,
            updateCollectionInstanceTracker,
            resetCollectionInstanceTracker,
            collectionInstanceTracker,
            changeForm,
            isValid,
            lookups,
        } = this.props;

        let content;
        if (collectionInstanceTracker) {
            let formComponents: { [index: string]: RegistrationFormComponent } =
                {
                    collectionInstanceTrackerTypeId: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: SelectFormInput,
                        inputDisabled: false,
                        inputLabel: "Tracking Type",
                        inputProps: {
                            value: collectionInstanceTracker.collectionInstanceTrackerTypeId,
                            options: generateOptionsFromLookup(
                                findLookup(
                                    "CollectionInstanceTracker",
                                    "CollectionInstanceTrackerTypeId",
                                    lookups
                                ),
                                0
                                    ? collectionInstanceTracker.collectionInstanceTrackerTypeId
                                    : 0
                            ),
                        },
                        changeAction: (model, value, form, parentModel) => {
                            const newForm = { ...form };
                            newForm.collectionInstanceTrackerTypeId = value;
                            updateCollectionInstanceTracker(newForm);
                        },
                    },
                    dateStarted: {
                        type: RegistrationComponent.RegistrationControl,
                        inputLabel: "Date Tracked",
                        inputType: DatePickerFormInputFabric,
                        inputDisabled: false,
                        inputProps: {
                            value: collectionInstanceTracker.date,
                        },
                        changeAction: (model, value, form, parentModel) => {
                            const newForm = { ...form };
                            newForm.date = value;
                            updateCollectionInstanceTracker(newForm);
                        },
                    },
                    comment: {
                        type: RegistrationComponent.RegistrationControl,
                        inputType: TextAreaFormInput,
                        inputDisabled: false,
                        inputLabel: "Comments",
                        inputProps: {
                            value: collectionInstanceTracker.comment,
                        },
                        changeAction: (model, value, form, parentModel) => {
                            const newForm = { ...form };
                            newForm.comment = value;
                            updateCollectionInstanceTracker(newForm);
                        },
                    },
                };
            content = (
                <div className="container-fluid">
                    {renderFormControls(
                        collectionInstanceTracker,
                        "collectionInstanceTrackerPage.collectionInstanceTracker",
                        formComponents,
                        lookups,
                        [],
                        [],
                        changeForm
                    )}
                </div>
            );
        }

        return (
            <Modal
                open={modalOpen}
                disableCloseOnOverlayClick={true}
                onClose={() => this.setState({ tracker: undefined })}
                size={ModalSize.Md}
            >
                <div className="modal-header">
                    <h5 className="modal-title">Tracking</h5>
                    <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => resetCollectionInstanceTracker()}
                    >
                        <FontAwesomeIcon
                            fixedWidth
                            icon={FontAwesomeIcons.Regular.TIMES}
                        />
                    </button>
                </div>
                <div className="modal-body py-0">{content}</div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-primary"
                        disabled={!isValid}
                        onClick={() => this.onUpdate()}
                    >
                        Ok
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger"
                        onClick={() => resetCollectionInstanceTracker()}
                    >
                        Cancel
                    </button>
                </div>
            </Modal>
        );
    }

    render() {
        const { values, lookups, editCollectionInstanceTracker } = this.props;

        return (
            <div>
                Tracking
                <div>
                    <table className="table table-bordered mt-2 mb-2 source-documents-source-documents">
                        <thead className="thead-light">
                            <tr>
                                <th style={{ width: "23%", minWidth: "150px" }}>
                                    Date
                                </th>
                                <th style={{ minWidth: "200px" }}>Comment</th>
                                <th style={{ width: "60px" }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {values &&
                                values.map((item, index) => (
                                    <tr>
                                        <td>
                                            <span>
                                                {convertToShortDateString(
                                                    item.date
                                                )}
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                {findLookupValue(
                                                    "CollectionInstanceTracker",
                                                    "CollectionInstanceTrackerTypeId",
                                                    item.collectionInstanceTrackerTypeId,
                                                    lookups
                                                )}
                                                {item.comment ? ": " : ""}
                                                {item.comment}{" "}
                                            </span>
                                        </td>
                                        <td>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-sm"
                                                onClick={() =>
                                                    editCollectionInstanceTracker(
                                                        index,
                                                        item
                                                    )
                                                }
                                            >
                                                Edit
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td colSpan={3} className="text-right">
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={this.onAdd}
                                    >
                                        Add
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                {this.renderModal()}
            </div>
        );

        /*
        <div>Item Documents
            <div>
            <table class="table table-bordered mt-2 mb-2 source-documents-source-documents">
            <thead class="thead-light">
            <tr>
            <th style="min-width: 200px;">FileName</th>
            <th style="width: 23%; min-width: 150px;">FileType</th>
            <th style="width: 20%; min-width: 150px;">Upload</th>
            </tr>
            </thead>
            <tbody>
            <tr>
            <td colspan="5" class="text-right">
            <div class="btn btn-primary">Add</div>
            </td>
            </tr>
            </tbody>
            </table>
            </div>
        </div>
        */
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps
): ICollectionInstanceTrackerPageProps => {
    return {
        collectionInstanceId: state.reduxForms.collectionInstance.id,
        values: state.reduxForms.collectionInstance
            ? state.reduxForms.collectionInstance.collectionInstanceTrackers
            : [],
        lookups: state.collectionInstance.lookups,
        modalOpen: state.collectionInstanceTrackerPage.modalOpen,
        isValid: state.collectionInstanceTrackerPage.isValid,
        collectionInstanceTrackerIndex:
            state.collectionInstanceTrackerPage.collectionInstanceTrackerIndex,
        collectionInstanceTracker:
            state.collectionInstanceTrackerPage.collectionInstanceTracker,
    };
};

const mapDispatchToProps = (
    dispatch
): ICollectionInstanceTrackerPageActions => {
    return {
        changeForm: bindActionCreators(actions.change, dispatch),

        addCollectionInstanceTracker: bindActionCreators(
            CollectionInstanceTrackerPageActions.createCollectionTracker,
            dispatch
        ),
        editCollectionInstanceTracker: bindActionCreators(
            CollectionInstanceTrackerPageActions.editCollectionTracker,
            dispatch
        ),
        updateCollectionInstanceTracker: bindActionCreators(
            CollectionInstanceTrackerPageActions.updateCollectionTracker,
            dispatch
        ),
        resetCollectionInstanceTracker: bindActionCreators(
            CollectionInstanceTrackerPageActions.resetCollectionTracker,
            dispatch
        ),
    };
};

const CollectionInstanceTrackerPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CollectionInstanceTrackerPage);

export default CollectionInstanceTrackerPageContainer;
